import { __assign, __extends } from "tslib";
import * as _ from '@antv/util';
import Element from './base';
import AreaShapeFactory from './shape/area';
import { splitData } from './util/split-data';
var Area = /** @class */ (function (_super) {
    __extends(Area, _super);
    function Area(cfg) {
        var _this = _super.call(this, __assign({ type: 'area', shapeType: 'area', generatePoints: true, sortable: true, connectNulls: false, showSinglePoint: false }, cfg)) || this;
        _this.set('shapeFactory', AreaShapeFactory);
        return _this;
    }
    Area.prototype.draw = function (data, container, shapeFactory, index) {
        var _this = this;
        var cfg = this.getDrawCfg(data[0]);
        var splitArray = splitData(data, this.get('connectNulls'), this.getYScale().field);
        cfg.origin = data; // path,line,area 等图的origin 是整个序列
        _.each(splitArray, function (subData, splitedIndex) {
            cfg.splitedIndex = splitedIndex; // 传入分割片段索引 用于生成id
            var points = subData.map(function (obj) {
                return obj.points;
            });
            cfg.points = points;
            var geomShape = shapeFactory.drawShape(cfg.shape, cfg, container);
            _this.appendShapeInfo(geomShape, index + splitedIndex);
        });
    };
    return Area;
}(Element));
export default Area;
//# sourceMappingURL=area.js.map